import { ChatHeaderProps } from './types';

export const getContainerStyles = (
  variant: ChatHeaderProps['variant'],
  isCompact: ChatHeaderProps['isCompact']
): string => {
  // For embedded variant (sidebar usage), always use simple relative positioning
  if (variant === 'embedded') {
    return 'relative w-full';
  }

  // For other variants (mobile/fullscreen), keep original logic
  if (isCompact) {
    return 'sticky top-0 z-10 w-full';
  }

  switch (variant) {
    case 'fullscreen':
      return 'fixed inset-0 z-10';
    case 'default':
    default:
      return 'absolute inset-0';
  }
};

export const gradientAnimationStyle = `
@keyframes gradientAnimation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.gradient-animation {
  background-size: 200% 200%;
  animation: gradientAnimation 3s ease-in-out infinite;
}
`;
